var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b538;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.75,35.37c1.98,0,3.58-1.65,3.58-3.52l.05-14.47c0-.67.69-1.12,1.29-1.09.54.03,1.13.49,1.13,1.25l-.04,14.47c0,3.14-2.81,5.81-5.95,5.81H8.16c-3.21,0-5.97-2.76-5.97-5.97l.02-23.82c0-3.08,2.75-5.78,5.78-5.79l14.49-.05c.73,0,1.24.6,1.24,1.25,0,.58-.5,1.22-1.25,1.22h-13.99c-2.24,0-3.86,1.61-3.86,3.86v23c0,2.24,1.62,3.87,3.86,3.86l23.26-.02Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.21,27.25l-3.83,1.3c-1.23.42-2.39.31-3.3-.56s-1.07-2.05-.65-3.29l1.3-3.86L30.46,3.11c1.15-1.15,2.93-1.28,4.09-.14l2.35,2.32c1.14,1.12,1.26,2.98.07,4.17l-17.76,17.78ZM35.52,7.4l-2.93-2.93-2.98,2.95,2.99,2.98,2.93-3ZM14.26,26.34l3.56-1.19,13.03-13.02-2.96-2.97-13.03,13.03-1.19,3.61c-.04.11.04.43.13.49.07.05.38.08.47.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.0a3d219ff613504bf2f4a0e18ec4adee.svg";
export { ForwardRef as ReactComponent };